import { signal } from "@lit-labs/signals";
import type { ColorScheme } from "@pentacode/core";

export const EXPERIMENTAL_DARK_SCHEME = "dark-experimental";

export type AppColorScheme = ColorScheme | typeof EXPERIMENTAL_DARK_SCHEME;

export const experimentalColorSchemeLabel = "Dunkel (Beta)";

export const COLOR_SCHEME_STORAGE_KEY = "pentacode:color-scheme";

export function loadClientColorScheme(): AppColorScheme {
    return (localStorage.getItem(COLOR_SCHEME_STORAGE_KEY) as AppColorScheme) || "system";
}

export const appColorScheme = signal<AppColorScheme>(loadClientColorScheme());
